import NetworkConfig from "../../../NetworkConfig";
import abi from "./abi.json";
const HoloWrapConfig = {
  address: NetworkConfig.addresses.HoloWrap,
  abi,
};

export default HoloWrapConfig;
